(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-content"] && !window.DesignMode) return;
  try {
     
(function () {
  document.addEventListener('DOMContentLoaded', function() {
    const links = document.querySelectorAll('a[href^="#"]');
    for (const link of links) {
        link.addEventListener('click', function(event) {
          event.preventDefault();
          const targetId = this.getAttribute('href');
          const targetElement = document.querySelector(targetId);
          if (targetElement) {
            window.scrollTo({
              top: targetElement.offsetTop,
              behavior: 'smooth'
            });
          }
        });
      }
    });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-porque"]) return;
  try {
     
(function () {
  document.addEventListener('DOMContentLoaded', function() {
    gsap.registerPlugin(ScrollTrigger);
    const tlHero = gsap.timeline({
      scrollTrigger: {
        trigger: '#hero-video',
        pin: true,
        start: 'top',
        end: 'bottom',
        scrub: 2,
      }
    });
    tlHero.from('#video-background', { y: "+=100%" });

    let tlPorque = gsap.timeline({
      scrollTrigger: {
        trigger: '#porque-tarareo',
        start: 'top top',
        end: 'bottom',
        pin: true,
        scrub: true
      }
    });
    tlPorque.from('.funcionalidad-ergonomia', { y: '100vh' })
      .from('.estetica', { y: '100vh' })
      .from('.innovacion', { y: '100vh' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    document.addEventListener('DOMContentLoaded', function() {
      const marquees = document.querySelectorAll('.marquee-item');
      marquees.forEach(marqueeString => {
        const marqueeContainer = marqueeString.parentNode;
        const viewportWidth = window.innerWidth;
        const stringWidth = marqueeString.offsetWidth;
        let repeatCount = Math.floor(viewportWidth / stringWidth);
        if (repeatCount <= 1) {
          repeatCount = Math.floor((viewportWidth * 2) / stringWidth);
          marqueeContainer.classList.remove('twcss-basis-screen');
          marqueeContainer.classList.add('twcss-basis-screen2x');
        }
        for (let i = 1; i < repeatCount; i++) {
          const clone = marqueeString.cloneNode(true);
          marqueeContainer.appendChild(clone);
        }
        const marqueeContainerClone = marqueeContainer.cloneNode(true);
        marqueeContainer.parentNode.appendChild(marqueeContainerClone);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-about"]) return;
  try {
    
(function () {
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.tooltip-item').forEach(container => {
      const tooltip = container.querySelector('.tooltip');
      let mouse = { x: 0, y: 0 };
      const ref = {
        getBoundingClientRect: () => ({
          top: mouse.y,
          right: mouse.x,
          bottom: mouse.y,
          left: mouse.x,
          width: 0,
          height: 0,
        }),
        clientWidth: 0,
        clientHeight: 0,
      };
      const popper = Popper.createPopper(ref, tooltip, {
        placement: 'bottom-start',
        modifiers: [
          {
            name: 'flip',
            options: {
              fallbackPlacements: ['right', 'left'],
              boundary: container,
            },
          },
          {
            name: 'offset',
            options: {
              offset: [10, 10],
            },
          },
        ],
      });

      container.addEventListener('mousemove', (event) => {
        const rect = container.getBoundingClientRect();
        mouse = {
          x: event.clientX,
          y: event.clientY
        };
        // tooltip.style.display = 'block';
        popper.update();
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-como-funcionamos"]) return;
  try {
     
(function () {
  document.addEventListener('DOMContentLoaded', function() {
    const links = document.querySelectorAll('a[href^="#"]');
    for (const link of links) {
        link.addEventListener('click', function(event) {
          event.preventDefault();
          const targetId = this.getAttribute('href');
          const targetElement = document.querySelector(targetId);
          if (targetElement) {
            window.scrollTo({
              top: targetElement.offsetTop,
              behavior: 'smooth'
            });
          }
        });
      }
    });
  
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-de-la-vista-nace-el-amor"]) return;
  try {
    
  (function () {
    document.addEventListener('DOMContentLoaded', function() {
  
      gsap.registerPlugin(ScrollTrigger);
      const triggerElement = document.querySelector("#tooltip-section");
      const elementHeight = triggerElement.offsetHeight;
      
      let mm = gsap.matchMedia();

      mm.add("(max-width: 989px)", () => {
        let tl = gsap.timeline({
          scrollTrigger: {
            trigger: "#stacked-at-scroll",
            start: "top",
            end: "bottom",
            scrub: 3,
            pin: true
          }
        });
        tl.from(".stacked-1", { y: '100vh' })
          .from(".stacked-2", { y: '100vh' })
          .from(".stacked-3", { y: '100vh' })
          .from(".avion-tarareo", { marginTop: 'auto', marginRight: 'auto', scale: 0.5, opacity: 0 })
          .from(".watch-products", { x: '25vw', opacity: 0 });
      });
      mm.add("(min-width: 990px)", () => {
        let tl = gsap.timeline({
          scrollTrigger: {
            trigger: triggerElement,
            start: `${elementHeight * 0.75}px center`,
            endTrigger: "#stacked-at-scroll",
            end: 'top',
            scrub: true
          }
        });
        tl.from(".avion-tarareo", { marginRight: 'auto', scale: 0.5, opacity: 0 });
        let tl2 = gsap.timeline({
          scrollTrigger: {
            trigger: "#stacked-at-scroll",
            start: "top",
            end: "bottom",
            scrub: 3,
            pin: true
          }
        });
        tl2.from(".stacked-1", { y: '100vh' })
          .from(".stacked-2", { y: '100vh' })
          .from(".stacked-3", { y: '100vh' })
          .from(".watch-products", { x: '25vw', opacity: 0 });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-diseno-de-linea"]) return;
  try {
    
  (function () {
    document.addEventListener('DOMContentLoaded', function() {
      let activeSpan = null;
      let activeFigure = null;
      document.querySelectorAll('.diseno-linea').forEach((link, index) => {
        const span = link.querySelector('span');
        const figure = document.getElementById(link.dataset.image);
        if (index === 0) {
          span.classList.add('active');
          figure.classList.remove('twcss-opacity-0');
          figure.classList.add('twcss-opacity-100');
          activeSpan = span;
          activeFigure = figure;
        }
        span.addEventListener('mouseover', () => {
          if (activeFigure && activeFigure !== figure) {
            activeFigure.classList.remove('twcss-opacity-100');
            activeFigure.classList.add('twcss-opacity-0');
          }
          figure.classList.remove('twcss-opacity-0');
          figure.classList.add('twcss-opacity-100');
          if (activeSpan && activeSpan !== span) {
            activeSpan.classList.remove('active');
          }
          span.classList.add('active');
          activeFigure = figure;
          activeSpan = span;
        });
      });
  
      const imagesProyectos = document.querySelectorAll(".slide-producto");
      const swiperProyectos = new Swiper(".swiper-producto", {
        autoplay: {
          delay: 3000,
        },
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        navigation: {
          nextEl: ".producto-next",
          prevEl: ".producto-prev",
        },
        on: {
          init: function () {
            imagesProyectos[0].classList.add("twcss-opacity-100");
            imagesProyectos[0].classList.remove("twcss-opacity-0");
          },
          realIndexChange: function () {
            let index = this.realIndex; // Adjusted index to match the zero-based indexing
            imagesProyectos.forEach((image, i) => {
              if (i === index) {
                image.classList.add("twcss-opacity-100");
                image.classList.remove("twcss-opacity-0");
              } else {
                image.classList.remove("twcss-opacity-100");
                image.classList.add("twcss-opacity-0");
              }
            });
          },
        }
      });
    });
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-diseno-personalizado"]) return;
  try {
     
(function () {
  document.addEventListener('DOMContentLoaded', function() {
    const links = document.querySelectorAll('a[href^="#"]');
    for (const link of links) {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        const targetId = this.getAttribute('href');
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop,
            behavior: 'smooth'
          });
        }
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"]) return;
  try {
    
(function () {
  document.addEventListener('DOMContentLoaded', function() {
    gsap.registerPlugin(ScrollTrigger);
    let tl = gsap.timeline({
      // yes, we can add it to an entire timeline!
      scrollTrigger: {
        trigger: '#hero-video',
        pin: true,
        start: 'top',
        end: 'bottom',
        scrub: 3,
      }
    });
    tl.from('#video-background', { y: "100vh", });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-proyectos"]) return;
  try {
    
(function () {
  document.addEventListener('DOMContentLoaded', function() {
    const imagesProyectos = document.querySelectorAll(".slide-proyecto");
    const swiperProyectos = new Swiper(".swiper-proyectos", {
      autoplay: {
        delay: 3000,
      },
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
      navigation: {
        nextEl: ".proyecto-prev",
        prevEl: ".proyecto-next",
      },
      breakpoints: {
        990: {
          slidesPerView: 3
        },
        1280: {
          slidesPerView: 5
        },
      },
      on: {
        init: function () {
          imagesProyectos[0].classList.add("twcss-opacity-100");
          imagesProyectos[0].classList.remove("twcss-opacity-0");
        },
        realIndexChange: function () {
          let index = this.realIndex; // Adjusted index to match the zero-based indexing
          imagesProyectos.forEach((image, i) => {
            if (i === index) {
              image.classList.add("twcss-opacity-100");
              image.classList.remove("twcss-opacity-0");
            } else {
              image.classList.remove("twcss-opacity-100");
              image.classList.add("twcss-opacity-0");
            }
          });
        },
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["producto"]) return;
  try {
    
(function () {
  document.addEventListener('DOMContentLoaded', function() {
    const swiper = new Swiper('.thumbnails', {
      loop: true,
      spaceBetween: 4,
      slidesPerView: 4.5,
      watchSlidesProgress: true,
    });
    const swiper2 = new Swiper('.main', {
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: swiper,
      },
    });

    const addToCartButton = document.querySelector("#ProductSubmitButton-template--17374963957956__main");
    const avaiableOptions = ['properties[Acrilico]', 'properties[Base]', 'properties[Led]', 'properties[Madera]', 'properties[Luz]', 'properties[Vinil]'];
    const radioNames = avaiableOptions.filter(radioGroup => {
      return document.querySelector(`input[name="${radioGroup}"]`);
    });
    const selectedGroups = new Set();
    function checkAllGroupsSelected() {
      if (selectedGroups.size === radioNames.length) {
        addToCartButton.disabled = false;
      } else {
        addToCartButton.disabled = true;
      }
    }
    function checkOptions(event) {
      const groupName = event.target.name;
      selectedGroups.add(groupName);
      checkAllGroupsSelected();
    }
    radioNames.forEach(radioGroup => {
      const optionInputs = document.querySelectorAll(`input[name="${radioGroup}"]`);
      if (optionInputs.length > 0) {
        optionInputs.forEach(optionInput => {
          optionInput.addEventListener('change', checkOptions);
        });
      }
    });
    checkAllGroupsSelected();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-image"]) return;
  try {
     
(function () {
  document.addEventListener('DOMContentLoaded', function() {
    const links = document.querySelectorAll('a[href^="#"]');
    for (const link of links) {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        const targetId = this.getAttribute('href');
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop,
            behavior: 'smooth'
          });
        }
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
